import axios from 'axios';

import { HTTP_REQUEST_TIMEOUT_MS } from '@/constants/http';

export const publicRequest = (baseURL: string) => {
  return axios.create({
    baseURL,
    timeout: HTTP_REQUEST_TIMEOUT_MS,
    headers: {
      'Content-Type': `application/json`,
    },
  });
};
